import { useState } from 'react';
import { UpdateJobRequest, Job } from '@recruitai/shared';
import { apiClient } from '../lib/api-client';

interface UseUpdateJobResult {
  updateJob: (jobId: string, data: UpdateJobRequest) => Promise<Job>;
  isLoading: boolean;
  error: Error | null;
}

export function useUpdateJob(): UseUpdateJobResult {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const updateJob = async (jobId: string, data: UpdateJobRequest): Promise<Job> => {
    try {
      setIsLoading(true);
      setError(null);
      
      const job = await apiClient.put<Job>(`/jobs/${jobId}`, data);
      return job;
    } catch (err) {
      const error = err instanceof Error ? err : new Error('Failed to update job');
      setError(error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    updateJob,
    isLoading,
    error,
  };
}
